import { AutogenModelProspectContact, AutogenRowProspectContact } from "./autogen/AutogenModelProspectContact";

export class ModelProspectContact extends AutogenModelProspectContact<RowProspectContact> {
	constructor() {
		super(RowProspectContact);
	}
}

export class RowProspectContact extends AutogenRowProspectContact {
}